module.exports = __webpack_public_path__ + "img/notice-arrow.5a1bfd49.svg";